<script lang="ts" setup>
import { ref, onMounted } from "vue";

const emits = defineEmits([
  "update-container-width",
  "init-local-storage",
  "on-page-resize"
]);

const dragBar = ref<HTMLElement>(null);
let lastXPosition = ref(0);
let delta = ref(0);
let bodyElement = document.getElementsByTagName('body')[0];

const getPageX = (event) => event.touches ? event.touches[0].pageX : event.pageX;

const onMouseUp = () => {
  window.removeEventListener("mousemove", onMouseMove);
  window.removeEventListener("touchmove", onMouseMove);
  bodyElement.style.userSelect = 'auto';
}

const onMouseDown = (event) => {
  lastXPosition.value = getPageX(event);
  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("touchmove", onMouseMove);
  delta.value = 0;
  bodyElement.style.userSelect = 'none';
}

const onMouseMove = (event) => {
  const pageX = getPageX(event);
  delta.value = pageX - lastXPosition.value;
  lastXPosition.value = pageX;
  localStorage.setItem('tree-view-width', lastXPosition.value );
  emits('update-container-width',delta.value);
}

const resetContainerWidth = () => {
  localStorage.removeItem('tree-view-width');
  emits('on-page-resize', null);
}

const getStoredWidth = () => {
  if(localStorage.getItem('tree-view-width') !== null) {
    return parseInt(localStorage.getItem('tree-view-width'));
  } else {
    return 340; // width default is 340px
  }
}

onMounted(() => {
  document.addEventListener('mouseup', onMouseUp);
  document.addEventListener('touchend', onMouseUp);
  window.addEventListener("resize",resetContainerWidth);
  emits('init-local-storage', getStoredWidth());
});
</script>

<template>
  <div class="tree-view--drag-bar" ref="dragBar" @touchstart="onMouseDown" @mousedown="onMouseDown"/>
</template>

<style lang="scss">
@use '/assets/css/theme/helpers/variables';
.tree-view--drag-bar {
  background-color: variables.$card-bg;
  width: 1.25em;
  cursor: col-resize;
  position: relative;
  touch-action: none;
  flex-shrink: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    background-color: variables.$icon-primary;
    width: .15rem;
    height: 1.25rem;
    border-radius: 50rem;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 150ms ease-in-out;
  }

  &::after {
    left: calc(50% - .2rem);
  }

  &::before {
    left: calc(50% + .2rem);
  }
}

.no-selection {
  user-select: none;
}
</style>
